import React, { useLayoutEffect} from "react";
import Swal from 'sweetalert2'

function IdleTimer() {
    // jwt and expiredTime value from sessionStorage
    let expiredTime = parseInt(sessionStorage.getItem("_expiredTime", 10))
    let jwt = sessionStorage.getItem("jwt")

    // Initial expiredTime
    const setExpiredTime = () => {
        sessionStorage.setItem("_expiredTime", 15 * 60 * 1000)
        // sessionStorage.setItem("_expiredTime", 10000)
    }

    // Review expiredTime whenever events are detected
    const eventHandler = (e) => {
        expiredTime = parseInt(sessionStorage.getItem("_expiredTime", 10))
        if(!jwt) {
            jwt = sessionStorage.getItem("jwt")
        }
    }

    useLayoutEffect(() => {

        window.addEventListener("mousemove", eventHandler)
        window.addEventListener("scroll", eventHandler)
        window.addEventListener("keydown", eventHandler)

        let timer = sessionStorage.getItem("_expiredTime")

        if(!timer) {
            expiredTime = 15 * 60 * 1000;
            // expiredTime = 10000;
        }

        setExpiredTime()

        if(interval) {
            clearInterval(interval);
        }

        // set logout timer
        const interval = setInterval(() => {

            clearInterval(interval);

            expiredTime -= 1000;

            if(expiredTime < 0 && jwt) { 
                Swal.fire({
                    text: '대기시간 초과로 로그아웃 됩니다.',
                    icon: 'error',
                    confirmButtonText: '로그아웃하기',
                    cancelButtonText: '로그인 유지하기',
                    confirmButtonAriaLabel: false,
                    focusConfirm:false,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                })
                .then(result => {
                    if(result.isConfirmed) {
                        // document.location.href = "/main"
                        
                        sessionStorage.removeItem("jwt")
                        sessionStorage.removeItem("_expiredTime")
                        sessionStorage.removeItem("userId");
                        sessionStorage.removeItem("isAdmin");
                        sessionStorage.removeItem("loginid");
                        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";

                        clearInterval(interval);
                    }

                    if(result.isDismissed) {
                        eventHandler()
                    }
                })

                expiredTime = 1 * 60 * 60 * 1000;
                // expiredTime = 10000;
            }

        }, 1000);

       
    }, [])

    console.log('a', expiredTime)


    return (
        <>
            
        </>
    )
}

export default IdleTimer
